import { BCMSRecord, BCMSStateManagerCRUD, DisabledPrompt, StateManager, useBCMSContext, useStateManager } from "@bcm-dev/bcms-vite";
import { WidgetContainer, WidgetView } from "components/shared";
import { PrimaryButton, SecondaryButton, UICheckbox } from "components/ui";
import Classes, { Account } from "model";
import React from "react";
import BatchesACHTableView from "../BatchesACHTableView";
import SearchOptionsFormView from "../SearchOptionsFormView";
import ACHSearch from "../SearchOptionsFormView/classes/ACHSearch";

/**
 * @function PendingACHBatchesWidget
 * @return {React.Component}
 * @exported true
 * @description This is the main widget used in ActivityACHPage.
 */
export default function PendingACHBatchesWidget(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
      data: state.data,
      ui: state.ui,

      onChange: prop => val => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", prop ], val)
        .submit(setState);
      },

      onSearchChange: prop => val => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "achSearch", prop ], val)
        .submit(setState);
      },

      onClear: () => {
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "achSearch" ], ACHSearch.init())
        .submit(setState);
      }
  });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
      <WidgetContent/>
    </StateManager>
  )
}

export const getDefaultData = () => ({
  //companyAccounts: CompanyAccount.initAll(), // may be used later
  //linkedAccounts: LinkedAccount.initAll(), // may be used later
  showSearchOptions: false,
  achSearch: ACHSearch.init(),
  businessAccounts: Account.initAllBusinessAsset()
});

export const getDefaultUI = () => ({
  // no ui changes for now
});

function WidgetContent(props) {
  const { data, onChange } = useStateManager();

  return (
  <WidgetContainer className="pending-ach-batches-widget">
    <WidgetView dataPoint="Pending_ACH_Batches_Label" text="Pending ACH Batches">
      <UICheckbox label="Show Search Options" value={ data.showSearchOptions ? "checked" : "" } 
        onChange={ onChange("showSearchOptions")} />
        { data.showSearchOptions && 
        <SearchOptionsFormView offsetAccounts={ data.businessAccounts } />
        }
      <BatchesACHTableView data={ data } />
        <div className="button-container flex-container flex-horizontal">
          <DisabledPrompt>
            <SecondaryButton className="export-button" text="Export" />
          </DisabledPrompt>
          <DisabledPrompt>
            <PrimaryButton className="reject-button" text="Reject" />
          </DisabledPrompt>
          <DisabledPrompt>
            <PrimaryButton className="approve-button" text="Approve" />
          </DisabledPrompt>
        </div>
    </WidgetView>
  </WidgetContainer>
  );
}
